/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Removed_LineInputs */

const vi_einvoice_draft_removed_line = /** @type {(inputs: Einvoice_Draft_Removed_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xóa khỏi hóa đơn, chỉ áp dụng khi bấm Lưu và xem lại nháp.`)
};

/**

* @param {Einvoice_Draft_Removed_LineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_removed_line = /** @type {((inputs?: Einvoice_Draft_Removed_LineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Removed_LineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_removed_line(inputs)
});